import React from 'react'
import { IProps } from './Interface'
import cxs from 'classnames/bind'
import {
  Box,
  Grid,
  GridDirection,
  GridItemsAlignment,
  Typography,
  FormLabel,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import useStyles from './Styles'
import { Balloon, Corner } from 'components/balloon'
import classnames from 'classnames'

const MoreAboutMePageDisplay: React.FC<IProps> = props => {
  const theme = useTheme()
  const xsSize = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles({})
  const cx = cxs.bind(classes)
  const labelClasses = cx({
    label: true,
    labelTop: false
  })

  const questions = [
    {
      questionKey: 'impactOn',
      label: 'I can create impact on',
      initialValue: props.impactOn
    },
    {
      questionKey: 'impactInterested',
      label: "because I'm interested in",
      initialValue: props.impactInterested
    },
    {
      questionKey: 'impactGoodAt',
      label: "because I'm motivated by",
      initialValue: props.impactGoodAt
    }
  ]

  return (
    <Box className={classes.root}>
      <Box
        className={classnames(
          classes.paragraphQuestion,
          {
            [classes.bottomRounded]: props.isLastChildren && !props.toGetMeTalking && !props.inDealingWithPeople
          },
          'more-about-me-i-can-create-impact-on-section'
        )}
      >
        <Box className={classes.paragraphContainer}>
          {questions.map(({ questionKey, label, initialValue }) => (
            <Box key={questionKey} mb={1}>
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextRoot}
              >
                <Grid item className={classes.labelContainer}>
                  <FormLabel id={`more-about-me-page-${questionKey}-label`} className={labelClasses}>
                    {label}
                  </FormLabel>
                </Grid>
                <Grid item className={classes.inputContainer}>
                  <Typography id={`more-about-me-page-${questionKey}-answer`}>{initialValue}</Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
          {'.'}
        </Box>
      </Box>

      <Box p={3} className={classes.questionsContainer}>
        {props.toGetMeTalking && (
          <Box className={cx(classes.questionContainerDisabled, 'more-about-me-if-you-want-to-get-me-talking-section')}>
            <Box display="flex">
              <Balloon
                size={xsSize ? 30 : 38}
                corner={xsSize ? Corner.MiddleRight : Corner.BottomLeft}
                shadow={false}
                bgColor={theme.palette.common.lightPurple}
                flexShrink={0}
                mr={2}
              />
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextDetailRoot}
              >
                <Grid item className={classes.titleInputContainer}>
                  <Typography
                    id={`more-about-me-page-to-get-me-talking-label`}
                    style={{ color: theme.palette.common.lightPurple }}
                  >
                    {'If you want to get me talking ask me about…'}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.detailBox}>
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextDetailRoot}
              >
                <Grid item className={classes.detailInputContainer}>
                  <Typography id={`more-about-me-page-to-get-me-talking-answer`}>{props.toGetMeTalking}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}

        {props.inDealingWithPeople && (
          <Box className={cx(classes.questionContainerDisabled, 'more-about-me-in-dealing-with-people-section')}>
            <Box display="flex">
              <Balloon
                size={xsSize ? 30 : 38}
                corner={xsSize ? Corner.MiddleRight : Corner.BottomLeft}
                shadow={false}
                bgColor={theme.palette.common.lightOrange}
                flexShrink={0}
                mr={2}
              />
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextDetailRoot}
              >
                <Grid item className={classes.titleInputContainer}>
                  <Typography
                    id={`more-about-me-page-in-dealing-with-people-label`}
                    style={{ color: theme.palette.common.lightOrange }}
                  >
                    {'In dealing with people, what’s your best attribute?'}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.detailBox}>
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextDetailRoot}
              >
                <Grid item className={classes.detailInputContainer}>
                  <Typography id={`more-about-me-page-in-dealing-with-people-answer`}>
                    {props.inDealingWithPeople}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

MoreAboutMePageDisplay.defaultProps = {
  isLastChildren: false
}

export default MoreAboutMePageDisplay
